<template>
  <AppLayout>
    <div v-if="isLoading"
         class="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
         style="z-index: 1050; background: rgba(255,255,255,0.7);">
      <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="container mt-4">
      <div class="container-fluid mb-2">
        <div class="row align-items-center">
          <div class="col d-flex align-items-center flex-wrap gap-2">
            <h4 class="my-0"><strong>{{ productionout_name }}</strong></h4>
            <Link :href="route('production.out.index')" class="btn btn-outline-primary"><i class="bi bi-list"></i>&nbsp;Powrót
              do listy
            </Link>
          </div>

          <div class="col-auto ms-auto" v-if="this.hiddenProducents.length > 0">
            <button @click="showHideProducents" class="btn btn-outline-info"><i class="bi bi-eye"></i>&nbsp;Pokaż
              ukrytych
            </button>
          </div>
          <div class="col-auto ms-auto" v-if="productionoutentries.length > 0">
            <button v-if="hasPermission('canDelProdukcjaOut')" @click="wyczysc" class="btn btn-outline-danger"><i
                class="bi bi-trash"></i>&nbsp;Wyczyść tabelę
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 col-md-4 mb-2 mb-md-0" v-if="hasPermission('canEditProdukcjaOut')">
            <label for="xlsxFile">Wczytaj plik xlsx z listą elementów</label>
            <input id="xlsxFile" type="file" @change="onFileSelected" accept=".xlsx"
                   class="form-control form-control-sm" style="max-width: 400px;" ref="xlsxFileInput"/>
          </div>
          <div v-if="showConflictModal" class="modal-backdrop"
               style="position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:1050;">
            <div class="modal-content p-4" style="background:white; border-radius:5px; width:500px; max-width:90vw;">
              <h5>Co zrobić z pozycjami, które się powtarzają?</h5>
              <div class="d-flex flex-column gap-2 mt-3">
                <button class="btn btn-outline-primary" @click="submitFileWithAction('sum')">Zsumuj ilości</button>
                <button class="btn btn-outline-warning" @click="submitFileWithAction('skip')">Zignoruj (pomiń)</button>
                <button class="btn btn-outline-success" @click="submitFileWithAction('new')">Dodaj jako nowe</button>
                <button class="btn btn-outline-danger mt-2" @click="cancelUpload">Anuluj</button>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4" v-if="productionoutentries.length > 0">
            <label for="csvFile" class="form-label">Wczytaj CSV z SMART</label>
            <input id="csvFile" type="file" @change="csvUpload" accept=".csv,text/csv"
                   class="form-control form-control-sm" style="max-width: 400px;"/>
          </div>
          <div class="col-12 col-md-4 d-flex justify-content-md-end mt-3 mt-md-0">
            <form @submit.prevent="submitArchived"
                  v-if="productionoutentries.length > 0 && hasPermission('canEditProdukcjaOut')"
                  class="d-flex align-items-center gap-2">
              <div class="form-check">
                <input id="productionoutarchived" type="checkbox" class="form-check-input" :checked="archived"
                       @change="changeProductionOutArchived"/>
                <label for="productionoutarchived" class="form-check-label h6">Archiwizuj</label>
              </div>
              <button v-if="archivedHasChanged" type="submit" class="btn btn-primary btn-sm">Zapisz</button>
            </form>
          </div>
        </div>
      </div>
      <div class="container-fluid mb-1" v-if="productionoutentries.length > 0">
        <div class="d-flex flex-wrap align-items-center gap-3">
          <form @submit.prevent="submitForm"
                v-if="productionoutentries.length > 0 && hasPermission('canEditProdukcjaOut')"
                class="d-flex align-items-start gap-2">
            <select v-model="form.customer_id" class="select2 form-select" id="sel_customer_id">
              <option value="" disabled selected>-- Dodaj kontrahenta --</option>
              <option v-for="customer in customers" :key="customer.id" :value="customer.id">
                {{ customer.name }}
              </option>
            </select>
            <button type="submit" class="btn btn-primary btn-sm">Dodaj</button>
          </form>
          <div class="d-flex align-items-center gap-2 ms-auto flex-wrap">
            <button class="btn btn-outline-info btn-sm" @click="downloadDrawingsZip">Pobierz paczkę rysunków</button>
            <button class="btn btn-success btn-sm" @click="exportToExcel">Eksportuj do Excel</button>
            <button class="btn btn-warning btn-sm" @click="pobierzZeSmart"><i class="bi bi-download"></i>&nbsp;Pobierz
              ze SMART
            </button>
            <div class="position-relative">
              <input type="text" class="form-control form-control-sm pe-5" placeholder="Szukaj..."
                     v-model="searchTermRaw">
              <button class="btn position-absolute end-0 top-0 bottom-0 d-flex align-items-center px-2"
                      @click="searchTermRaw = ''" style="border: none; background: transparent;"><i
                  class="bi bi-x-lg"></i></button>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4" v-if="productionoutentries.length > 0">
        <button @click="scrollLeft" class="btn btn-outline-primary btn-sm" style="margin-right: 10px;">←</button>
        <button @click="scrollRight" class="btn btn-outline-primary btn-sm">→</button>
      </div>

      <div class="table-responsive mt-3" ref="tableWrapper" style="overflow-x: auto;"
           v-if="productionoutentries.length > 0">
        <table class="table table-bordered table-hover">
          <thead>
          <tr>
            <th colspan="7" class="text-center align-middle position-relative">
              <div class="d-flex flex-column align-items-center position-relative"><h2>{{ productionout_name }}</h2>
              </div>
            </th>
            <th v-for="(producent, index) in visibleProducents" :colspan="4" :key="producent.id"
                class="text-center align-middle position-relative" :draggable="true"
                @dragstart="onDragStart($event, index)" @dragover.prevent @drop="onDrop($event, index)"
                :style="{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '', borderLeft: '2px solid #888', cursor: 'grab' }">
              <div class="d-flex flex-column align-items-center">
                <a :href="`/producents_out/show/${producent.id}`" target="_blank"
                   style="cursor:pointer; color:blue;"><strong>{{ producent.short_name }}</strong></a>
                <label class="mt-1">Suma: <strong>{{ calculateTotalForProducent(producent.id) }}</strong></label>
                <small v-if="producent.cena_ustalona">Wartość ustalona: {{ producent.cena_ustalona }}</small>
                <small v-if="producent.cena_ustalona" class="mt-1">Różnica:
                  <strong>{{ calculateProcent(producent.id, producent.cena_ustalona) }}%</strong></small>
              </div>
              <div class="position-absolute top-0 end-0 d-flex gap-1 me-1 mt-1">
                <button type="button" class="btn btn-sm-oko btn-info" title="Ukryj" @click="hideProducent(producent.id)"
                        @mouseenter="hoverStates[producent.id] = true" @mouseleave="hoverStates[producent.id] = false">
                  <i :class="hoverStates[producent.id] ? 'bi bi-eye-slash' : 'bi bi-eye'"></i></button>
                <button v-if="hasPermission('canDelProdukcjaOut')" type="button" class="btn btn-sm-kosz btn-danger"
                        title="Usuń" @click="removeProducent(producent.id)"><i class="bi bi-trash"></i></button>
              </div>
            </th>
          </tr>
          <tr>
            <th>#</th>
            <th style="position: sticky; top: 0; left: 0px; background: white; z-index: 20;max-width: 100px;">
              Miniatura
            </th>
            <th style="min-width: 150px; max-width: 160px; cursor: pointer;" @click="sortBy('part_number')">Numer
              rysunku <i v-if="sortColumn === 'part_number'"
                         :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i></th>
            <th style="min-width: 50px; max-width: 55px; cursor: pointer;" @click="sortBy('qty')">Ilość <i
                v-if="sortColumn === 'qty'"
                :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i></th>
            <th style="min-width: 160px; max-width: 200px; cursor: pointer;" @click="sortBy('description')">Opis <i
                v-if="sortColumn === 'description'"
                :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i></th>
            <th style="cursor: pointer;" @click="sortBy('smart')">SMART <i v-if="sortColumn === 'smart'"
                                                                           :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
            </th>
            <th style="min-width: 170px; max-width: 200px; cursor: pointer;" @click="sortBy('status')">Status <i
                v-if="sortColumn === 'status'"
                :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i></th>
            <template v-for="(producent, index) in producentsoutlist" :key="'header-' + producent.id"
                      :style="{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : '', borderLeft: '2px solid #888'}">
              <th v-if="!hiddenProducents.includes(producent.id)"
                  :style="{borderLeft: '2px solid #888', minWidth: '120px', maxWidth: '220px' }"
                  @click="sortBy('cena_' + producent.id)" style="cursor: pointer;">Cena/szt.<i
                  v-if="sortColumn === ('cena_' + producent.id)"
                  :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i></th>
              <th v-if="!hiddenProducents.includes(producent.id)" @click="sortBy('wartosc_' + producent.id)"
                  style="min-width: 120px; cursor: pointer;">Wartość<i v-if="sortColumn === ('wartosc_' + producent.id)"
                                                                       :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th v-if="!hiddenProducents.includes(producent.id)" @click="sortBy('uwagi_' + producent.id)"
                  style="min-width: 120px; cursor: pointer;">Uwagi<i v-if="sortColumn === ('uwagi_' + producent.id)"
                                                                     :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
              <th v-if="!hiddenProducents.includes(producent.id)" @click="sortBy('dostawa_' + producent.id)"
                  style="min-width: 120px; cursor: pointer;">Dostawa<i v-if="sortColumn === ('dostawa_' + producent.id)"
                                                                       :class="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
              </th>
            </template>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(entry, index) in sortedEntries" :key="entry.item_id || index">
            <td>{{ index + 1 }}<i v-if="hasPermission('canDelProdukcjaOut')" class="bi bi-trash text-danger"
                                  style="cursor: pointer;" title="Usuń" @click="removeProduct(entry.id)"></i></td>
            <td style="background: white; position: sticky; left: 0px; z-index: 10;">
              <img v-if="entry.thumbnail" :src="entry.thumbnail" alt="thumbnail"
                   style="max-width: 80px; max-height: 80px; cursor: pointer; opacity: entry.barcode ? 1 : 0.4"
                   loading="lazy" @click="entry.barcode ? openPdfIfBarcode(entry) : null"
                   :title="entry.barcode ? 'Otwórz PDF' : 'Brak kodu kreskowego'">
            </td>
            <td v-if="hasPermission('canEditProdukcjaOut')" @click="openModal(entry, 'part_number')"
                style="cursor: pointer;width: 160px;">{{ entry.part_number || '' }}
            </td>
            <td v-else style="width: 160px;">{{ entry.part_number || '' }}</td>
            <td v-if="hasPermission('canEditProdukcjaOut')" @click="openModal(entry, 'qty')" style="cursor: pointer;">
              {{ entry.qty || '' }}
            </td>
            <td v-else>{{ entry.qty || '' }}</td>
            <td v-if="hasPermission('canEditProdukcjaOut')" @click="openModal(entry, 'description')"
                style="min-width: 160px; max-width: 200px; cursor: pointer;">{{ entry.description || '' }}
            </td>
            <td v-else style="min-width: 160px; max-width: 200px;">{{ entry.description || '' }}</td>
            <td v-if="hasPermission('canEditProdukcjaOut')" @click="openModal(entry, 'smart')" style="cursor: pointer;">
              {{ entry.smart || '' }}
            </td>
            <td v-else>{{ entry.smart || '' }}</td>
            <td v-if="hasPermission('canEditProdukcjaOut')" style="min-width: 170px;">
              <select v-model="entry.status" class="form-control form-control-sm w-100" @change="saveStatus(entry)"
                      tabindex="-1">
                <option :value="null"></option>
                <option v-for="status in statusy" :key="status.id" :value="status.id"><small>{{ status.name }}</small>
                </option>
              </select>
            </td>
            <td v-else style="min-width: 170px;">{{ entry.status_relation ? entry.status_relation.name : '' }}</td>
            <template v-for="producent in visibleProducents" :key="'row-' + producent.id">
              <td v-if="!hiddenProducents.includes(producent.id)"
                  :style="{ backgroundColor: entry['selected_' + producent.id] == 1 ? '#40E0D0' : '', borderLeft: '2px solid #888' }">
                <div v-if="hasPermission('canEditProdukcjaOut')" class="d-flex flex-column">
                  <input v-model="entry['cena_' + producent.id]" type="text" class="form-control form-control-sm mb-1"
                         @input="validateCena(entry, producent.id)" @keyup="saveCenaAuto(entry, producent.id)"
                         @change="saveCenaAuto(entry, producent.id)" style="min-width: 100px; border-radius: 0;">
                  <div class="form-check" v-if="entry['cena_' + producent.id]">
                    <input class="form-check-input" type="checkbox"
                           :id="'selectedCheckbox_' + producent.id + '_' + entry.item_id"
                           v-model="entry['selected_' + producent.id]" :true-value="1" :false-value="0"
                           @change="saveCenaAuto(entry, producent.id)">
                    <small class="form-check-label" :for="'selectedCheckbox_' + producent.id + '_' + entry.item_id">Wybierz</small>
                  </div>
                  <small
                      v-if="producent.cena_ustalona && entry['cena_' + producent.id] && entry['selected_' + producent.id] == 1">Ustalona:
                    ~{{ calculateCena2(producent.id, producent.cena_ustalona, entry['cena_' + producent.id]) }}</small>
                </div>
                <div v-else>{{ entry['cena_' + producent.id] }}</div>
              </td>
              <td v-if="!hiddenProducents.includes(producent.id)">
                <span v-if="entry['cena_' + producent.id] && entry.qty">{{
                    calculateWartosc(entry, producent.id)
                  }}</span><br>
                <small
                    v-if="producent.cena_ustalona && entry['cena_' + producent.id] && entry['selected_' + producent.id] == 1">Ustalona:
                  ~{{
                    calculateWartosc2(entry, producent.id, calculateProcent(producent.id, producent.cena_ustalona))
                  }}</small>
              </td>
              <td v-if="!hiddenProducents.includes(producent.id)"
                  @click="hasPermission('canEditProdukcjaOut') ? openModal(entry, 'uwagi_' + producent.id) : null"
                  style="cursor: pointer;">
                {{ entry['uwagi_' + producent.id] || '' }}
              </td>
              <td v-if="!hiddenProducents.includes(producent.id)"
                  @click="hasPermission('canEditProdukcjaOut') ? openModal(entry, 'dostawa_' + producent.id) : null"
                  style="cursor: pointer;">
                {{ formatDate(entry['dostawa_' + producent.id]) }}
              </td>
            </template>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-show="isModalOpen" class="modal fade show" tabindex="-1"
           :style="{ display: isModalOpen ? 'block' : 'none' }">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edycja</h5>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body">

              <div v-if="editedField && editedField.includes('dostawa')">
                <input v-model="editedValue" type="date" class="form-control mb-2"/>
                <input :value="formatDisplayDate(editedValue)" class="form-control" placeholder="DD.MM.RRRR"
                       @input="onManualDateInput($event.target.value)"/>
              </div>

              <input v-else-if="editedField && editedField !== 'description' && !editedField.startsWith('uwagi_')"
                     v-model="editedValue" :type="editedField === 'qty' ? 'number' : 'text'" class="form-control"/>
              <textarea v-else-if="editedField" v-model="editedValue" class="form-control" rows="3"></textarea>
              <div v-if="editedField && editedField.startsWith('cena_')" class="mb-3 mt-3">
                <input type="checkbox" id="modalCheckbox" v-model="modalCenaCheckbox" class="me-3"/>
                <label for="modalCheckbox">Wybierz tego producenta</label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="closeModal">Anuluj</button>
              <button
                  v-if="editedField && editedField !== 'description' && editedField !== 'qty' && editedField !== 'smart' && editedField !== 'part_number'"
                  type="button" class="btn btn-primary" @click="saveField">Zapisz
              </button>
              <button v-else class="btn btn-primary" @click="saveField2">Zapisz</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {router} from "@inertiajs/vue3";
import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";
import {Tooltip} from 'bootstrap';
import {isDisabled} from "bootstrap/js/src/util/index.js";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import {useForm} from "@inertiajs/vue3";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, hasPermission},
  props: {
    prid: {type: String, required: true},
    productionout_name: {type: String, required: true},
    archived: {type: Boolean, required: true},
    customers: {
      type: Array,
      default: () => []
    },
    producentsoutlist: {type: Array, default: () => []},
    producentsoutdata: {type: Array, default: () => []},
    statusy: {type: Array, default: () => []},
    productionout_data: {type: Array, default: () => []},
  },
  data() {
    return {
      searchTermRaw: '',
      searchTerm: '',
      debounceTimer: null,

      selectedFile: null,
      showConflictModal: false,
      conflictAction: null,

      draggedIndex: null,

      isLoading: false,
      editedEntry: null,
      editedField: null,
      editedValue: '',
      selectedCustomerId: '',
      modalCenaCheckbox: false,
      hiddenProducents: [],
      isModalOpen: false,
      hasPermission,
      archiveOnListForm: useForm({
        archived: this.archived
      }),
      archivedHasChanged: false,
      productionoutentries: [],
      sortColumn: '',
      sortDirection: 'asc',
      hoverStates: {},
      form: {
        customer_id: '',
        csvComparisonResults: [],
      }
    };
  },
  watch: {
    searchTermRaw(newVal) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.searchTerm = newVal;
      }, 200);
    }
  },
  computed: {
    filteredEntries() {
      const term = this.searchTerm?.trim().toLowerCase();
      if (!term) return this.productionoutentries;

      return this.productionoutentries.filter(entry => {
        return ['part_number', 'description', 'smart'].some(key =>
            (entry[key] || '').toLowerCase().includes(term)
        ) || (entry.status_relation?.name || '').toLowerCase().includes(term);
      });
    },
    visibleProducents() {
      return this.producentsoutlist.filter(
          (p) => !this.hiddenProducents.includes(p.id)
      );
    },
    sortedEntries() {
      const sorted = [...this.filteredEntries].sort((a, b) => {
        const key = this.sortColumn;
        let aVal = a[key];
        let bVal = b[key];
        if (key?.startsWith('wartosc_')) {
          const producentId = key.replace('wartosc_', '');
          aVal = parseFloat(a[`cena_${producentId}`] || 0) * parseFloat(a.qty || 0);
          bVal = parseFloat(b[`cena_${producentId}`] || 0) * parseFloat(b.qty || 0);
        }
        if (aVal == null) aVal = '';
        if (bVal == null) bVal = '';
        if (!isNaN(aVal) && !isNaN(bVal)) {
          return this.sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
        }
        return this.sortDirection === 'asc'
            ? aVal.toString().localeCompare(bVal.toString())
            : bVal.toString().localeCompare(aVal.toString());
      });
      return sorted;
    },
  },
  mounted() {
    this.loadData();
    this.handleSelect2();
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    });
  },

  methods: {
    onDragStart(event, index) {
      this.draggedIndex = index; // zapamiętujemy indeks producenta
      event.dataTransfer.effectAllowed = "move";
    },
    onDrop(event, dropIndex) {
      if (this.draggedIndex === null || this.draggedIndex === undefined) return;

      // Sprawdzenie czy któryś z producentów jest ukryty
      const anyHidden = this.producentsoutlist.some(p => this.hiddenProducents.includes(p.id));
      if (anyHidden) {
        this.showToast('error', 'Uwaga', 'Nie można przenosić ponieważ jeden lub więcej producentów jest ukryty!');
        this.draggedIndex = null;
        return;
      }


      const moved = this.producentsoutlist.splice(this.draggedIndex, 1)[0];
      this.producentsoutlist.splice(dropIndex, 0, moved);

      this.draggedIndex = null;

      // opcjonalnie zapis do bazy
      const order = this.producentsoutlist.map((p, i) => ({id: p.id, sort_order: i + 1}));
      console.log(order);
      console.log(this.prid);
      fetch("/production_out/save-order", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({prid: this.prid, order})
      })
          .then(res => res.json())
          .then(res => {
            if (res.status === 'ok') {
              this.showToast('success', 'Zapisano', 'Nowa kolejność producentów została zapisana');
            }
          })
          .catch(() => {
            this.showToast('error', 'Błąd', 'Nie udało się zapisać kolejności');
          });
    },
    async pobierzZeSmart() {
      const expr1 = this.productionout_name?.split('-')?.[0]?.trim();
      if (!expr1 || !this.prid) {
        this.showToast("error", "Błąd", "Brakuje danych do pobrania ze SMART");
        return;
      }

      this.isLoading = true;
      try {
        await axios.get(`/smart-list/${expr1}/${this.prid}`);
        this.showToast("success", "Zapisano", "Status z SMART został zaktualizowany");
      } catch (error) {
        console.error(error);
        this.showToast("error", "Błąd", "Nie udało się zapisać statusu");
      } finally {
        this.isLoading = false;
        await this.loadData();
      }
    },

    cancelUpload() {
      this.showConflictModal = false;
      this.selectedFile = null;
      if (this.$refs.xlsxFileInput) {
        this.$refs.xlsxFileInput.value = null;
      }
    },

    onFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.selectedFile = file;
      this.showConflictModal = true;
    },


    submitFileWithAction(action) {
      this.conflictAction = action;
      this.showConflictModal = false;
      this.isLoading = true;

      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("prid", this.prid);
      formData.append("conflictAction", action);

      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      fetch(route('production.out.showimage'), {
        method: "POST",
        headers: {
          "X-CSRF-TOKEN": csrfToken,
          Accept: "application/json",
        },
        body: formData,
      })
          .then(response => {
            if (!response.ok) throw new Error('Błąd uploadu pliku');
            return response.json();
          })
          .then(data => {
            this.isLoading = false;
            this.productionoutentries = data;
            this.showToast("success", "Plik załadowany", `Wczytano ${data.length} rekordów`);
          })
          .catch(error => {
            console.error(error);
            this.isLoading = false;
            this.showToast("error", "Błąd", "Nie udało się przetworzyć pliku");
          })
          .finally(() => {
            this.selectedFile = null;
            this.conflictAction = null;
            if (this.$refs.xlsxFileInput) {
              this.$refs.xlsxFileInput.value = null;
            }
          });
    },

    async downloadDrawingsZip() {
      const entriesWithBarcode = this.sortedEntries.filter(entry => entry.barcode);
      if (!entriesWithBarcode.length) {
        alert('Brak rysunków z kodem kreskowym do pobrania.');
        return;
      }

      const barcodes = entriesWithBarcode.map(entry => entry.barcode);

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/production_out/download-zip';
      form.target = '_blank';

      const csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      const csrfInput = document.createElement('input');
      csrfInput.type = 'hidden';
      csrfInput.name = '_token';
      csrfInput.value = csrf;
      form.appendChild(csrfInput);

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'barcodes';
      input.value = JSON.stringify(barcodes);
      form.appendChild(input);

      const nameInput = document.createElement('input');
      nameInput.type = 'hidden';
      nameInput.name = 'nazwa';
      nameInput.value = this.productionout_name;
      form.appendChild(nameInput);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },

    async openPdfIfBarcode(entry) {
      if (!entry.barcode) {
        alert('Brak kodu kreskowego');
        return;
      }
      const fileName = entry.barcode + '.pdf';
      const downloadUrl = route('production.out.files.download', {file: fileName});
      try {
        const res = await fetch(downloadUrl, {
          method: 'HEAD',
          credentials: 'same-origin'
        });
        if (res.ok) {
          window.open(downloadUrl, '_blank');
        } else {
          alert('Plik nie istnieje.');
        }
      } catch (err) {
        alert('Błąd połączenia.');
      }
    },

    formatDisplayDate(value) {
      if (!value || value.length !== 10) return '';
      const [yyyy, mm, dd] = value.split('-');
      return `${dd}.${mm}.${yyyy}`;
    },

    onManualDateInput(input) {
      const match = input.match(/^(\d{2})[./-](\d{2})[./-](\d{4})$/);
      if (match) {
        const [_, dd, mm, yyyy] = match;
        this.editedValue = `${yyyy}-${mm}-${dd}`;
      }
    },

    exportToExcel() {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/production_out/export-to-excel';
      form.target = '_blank';
      const csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      const csrfInput = document.createElement('input');
      csrfInput.type = 'hidden';
      csrfInput.name = '_token';
      csrfInput.value = csrf;
      form.appendChild(csrfInput);

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'data';
      input.value = JSON.stringify(this.sortedEntries);
      form.appendChild(input);

      const statusInput = document.createElement('input');
      statusInput.type = 'hidden';
      statusInput.name = 'statusy';
      statusInput.value = JSON.stringify(this.statusy);
      form.appendChild(statusInput);

      const nameInput = document.createElement('input');
      nameInput.type = 'hidden';
      nameInput.name = 'nazwa';
      nameInput.value = this.productionout_name;
      form.appendChild(nameInput);

      const producentsInput = document.createElement('input');
      producentsInput.type = 'hidden';
      producentsInput.name = 'producents';
      producentsInput.value = JSON.stringify(this.producentsoutlist);
      form.appendChild(producentsInput);

      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'hiddenProducents';
      hiddenInput.value = JSON.stringify(this.hiddenProducents);
      form.appendChild(hiddenInput);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },

    sortBy(columnKey) {
      if (this.sortColumn === columnKey) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = columnKey;
        this.sortDirection = 'asc';
      }
    },

    saveStatus(entry) {
      const payload = {
        prid: this.prid,
        id: entry.id,
        status: entry.status
      };

      this.$inertia.post(route('production.out.update.data'), payload, {
        preserveScroll: true,
        onSuccess: () => {
          this.showToast("success", "Zapisano", "Status został zaktualizowany");
        },
        onError: () => {
          this.showToast("error", "Błąd", "Nie udało się zapisać statusu");
        }
      });
    },

    validateCena(entry, producentId) {
      const key = 'cena_' + producentId;
      let val = entry[key];
      val = val.replace(/[^\d.,]/g, '');
      val = val.replace(',', '.');
      entry[key] = val;
    },
    saveCenaAuto(entry, producentId) {
      const rawValue = entry['cena_' + producentId];
      const cleanedValue = rawValue?.toString().replace(',', '.').trim();
      const isEmpty = cleanedValue === '' || cleanedValue === null || cleanedValue === undefined;

      let numericValue = null;
      if (!isEmpty) {
        numericValue = parseFloat(cleanedValue);
        if (isNaN(numericValue)) {
          this.showToast("error", "Nieprawidłowa wartość", "Wprowadź poprawną liczbę lub zostaw puste.");
          return;
        }
      }
      const customerId = parseInt(producentId);
      if (!customerId) {
        this.showToast("error", "Brak kontrahenta", "Nie można zapisać bez przypisanego kontrahenta.");
        return;
      }
      const itemId = entry.item_id || entry.id || entry.item || entry.part_number;
      if (!itemId) {
        this.showToast("error", "Brak ID pozycji", "Nie można zapisać bez ID pozycji.");
        return;
      }
      const payload = {
        prid: this.prid,
        customer_id: customerId,
        item_id: itemId,
        cena: numericValue,
        selected: entry['selected_' + producentId] === 1 ? 1 : 0,
      };
      this.$inertia.post(route('producent.out.store.data'), payload, {
        preserveScroll: true,
        onSuccess: () => {
        },
        onError: (errors) => {
          this.showToast("error", "Błąd", "Nie udało się zapisać ceny.");
          console.error(errors);
        },
      });
    },

    async csvUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.isLoading = true;

      const formData = new FormData();
      formData.append('file', file);
      formData.append('prid', this.prid);

      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      try {
        const response = await fetch(route('production.out.getcsv'), {
          method: 'POST',
          headers: {
            'X-CSRF-TOKEN': csrfToken,
            'Accept': 'application/json',
          },
          body: formData
        });

        if (!response.ok) {
          throw new Error('Błąd podczas wysyłania pliku CSV');
        }
        this.isLoading = false;
        const data = await response.json();
        this.csvComparisonResults = data;
        await this.loadData();
        event.target.value = null;
        this.showToast("success", "CSV wczytany", `Znaleziono ${data.length} pasujących rekordów`);
      } catch (error) {
        event.target.value = null;
        this.isLoading = false;
        this.showToast("error", "Błąd", "Nie udało się przetworzyć pliku CSV");
      }
    },
    submitArchived() {
      this.$inertia.post(
          route('production.out.updateArchived', {production_out: this.prid}),
          {
            archived: this.archiveOnListForm.archived
          },
          {
            preserveScroll: true,
            onSuccess: () => {
              this.archivedHasChanged = false;
              this.showToast('success', 'Sukces', 'Status archiwizacji został zaktualizowany.');
            },
            onError: () => {
              this.showToast('error', 'Błąd', 'Nie udało się zapisać zmian.');
            }
          }
      );
    },
    changeProductionOutArchived() {
      this.archiveOnListForm.archived = event.target.checked;
      this.archivedHasChanged = true;
    },
    scrollLeft() {
      this.$refs.tableWrapper.scrollBy({left: -100, behavior: 'smooth'});
    },
    scrollRight() {
      this.$refs.tableWrapper.scrollBy({left: 100, behavior: 'smooth'});
    },

    calculateTotalForProducent(producentId) {
      let total = 0;
      this.productionoutentries.forEach(entry => {
        if (entry['selected_' + producentId] == 1) {
          const cena = parseFloat(entry['cena_' + producentId] || 0);
          const qty = parseFloat(entry.qty || 0);
          total += cena * qty;
        }
      });
      return total.toFixed(2);
    },

    calculateProcent(producentId, cena2) {
      let total = 0;
      let procent = 0;
      this.productionoutentries.forEach(entry => {
        if (entry['selected_' + producentId] == 1) {
          const cena = parseFloat(entry['cena_' + producentId] || 0);
          const qty = parseFloat(entry.qty || 0);
          total += cena * qty;
        }
      });
      if (total === 0) return '0.00';
      procent = ((total - cena2) / total) * (-100);
      return procent.toFixed(2);
    },

    calculateCena2(producentId, cena2, cena1) {
      let total = 0;
      this.productionoutentries.forEach(entry => {
        if (entry['selected_' + producentId] == 1) {
          const cena = parseFloat(entry['cena_' + producentId] || 0);
          const qty = parseFloat(entry.qty || 0);
          total += cena * qty;
        }
      });
      if (total === 0) return '0.00';
      let newcena = cena1 - (cena1 * ((total - cena2) / total));
      return newcena.toFixed(2);
    },

    calculateWartosc2(entry, producentId, procent) {
      const qty = parseFloat(entry.qty || 0);
      const cena_org = parseFloat(entry['cena_' + producentId] || 0);
      const prc = -parseFloat(procent || 0);
      let newwartosc = cena_org - (cena_org * (prc / 100));
      const result = (qty * newwartosc).toFixed(1);
      return this.formatNumber(result);
    },

    formatNumber(num) {
      let rounded = Math.round(num * 10) / 10;
      let str = rounded.toString();
      if (str.indexOf('.') === -1) {
        str += '.00';
      } else {
        let decimalPart = str.split('.')[1];
        if (decimalPart.length === 1) {
          str += '0';
        }
      }
      return str;
    },

    hideProducent(id) {
      if (!this.hiddenProducents.includes(id)) {
        this.hiddenProducents.push(id);
      }
    },


    showHideProducents() {
      this.hiddenProducents = [];
    },

    shouldHideRow(entry) {
      return false;
    },

    removeProducent(id) {
      if (!confirm('Na pewno usunąć tego producenta z listy?')) return;

      this.$inertia.delete(route('production.out.remove.producent', {prid: this.prid, customer_id: id}), {
        onSuccess: () => {
          this.showToast('info', 'Usunięto', 'Kontrahent został usunięty');
        }
      });
    },

    removeProduct(id) {
      if (!confirm('Na pewno usunąć tą pozycję z listy?')) return;

      this.$inertia.delete(route('production.out.remove.product', {prid: this.prid, id: id}), {
        onSuccess: () => {
          this.productionoutentries = this.productionoutentries.filter(entry => {
            return entry.id !== id;
          });
          this.showToast('info', 'Usunięto', 'Pozycja została usunięta.');
        }
      });
    },

    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    },

    calculateWartosc(entry, producentId) {
      const cena = parseFloat(entry['cena_' + producentId] || 0);
      const qty = parseFloat(entry.qty || 0);
      return (cena * qty).toFixed(2);
    },

    fieldLabel(field) {
      switch (field) {
        case 'part_number':
          return 'Numer rysunku';
        case 'qty':
          return 'Ilość';
        case 'description':
          return 'Opis';
        default:
          return field;
      }
    },
    openModal(entry, field) {
      this.editedEntry = entry;
      this.editedField = field;

      if (field.startsWith('cena_')) {
        const producentId = field.split('_')[1];
        this.modalCenaCheckbox = entry['selected_' + producentId] == 1;
        this.editedValue = entry[field] || '';
      } else if (field.startsWith('cena_ustalona_')) {
        const producentId = field.split('_')[2];
        this.editedValue = this.calculateWartosc2(entry, producentId);
      } else if (field === 'status') {
        this.editedValue = entry.status || '';
        this.modalCenaCheckbox = false;
      } else {
        this.editedValue = entry[field] || '';
        this.modalCenaCheckbox = false;
      }

      this.isModalOpen = true;
    },

    saveField() {
      if (this.editedEntry && this.editedField) {
        const producentId = this.editedField.split("_")[1];
        let customerId = null;

        if (this.editedField.startsWith("cena_") || this.editedField.startsWith("uwagi_") || this.editedField.startsWith("dostawa_")) {
          customerId = parseInt(producentId);
        } else {
          customerId = this.form.customer_id || this.editedEntry.customer_id || this.productionoutentries[0]?.customer_id;
        }

        if (!customerId) {
          this.showToast("error", "Brak kontrahenta", "Nie można zapisać bez przypisanego kontrahenta.");
          return;
        }

        this.editedEntry[this.editedField] = this.editedValue;

        if (this.editedField.startsWith("cena_")) {
          this.editedEntry['selected_' + producentId] = this.modalCenaCheckbox ? 1 : 0;
        }

        const payload = {
          prid: this.prid,
          customer_id: customerId,
          item_id: this.editedEntry.item_id || this.editedEntry.id || this.editedEntry.item || this.editedEntry.part_number,
        };

        if (this.editedField.startsWith("cena_")) {
          payload.cena = this.editedValue;
          payload.selected = this.modalCenaCheckbox ? 1 : 0;
        } else if (this.editedField.startsWith("uwagi_")) {
          payload.uwagi = this.editedValue;
        } else if (this.editedField.startsWith("dostawa_")) {
          payload.dostawa = this.editedValue;
        } else {
          payload[this.editedField] = this.editedValue;
        }

        this.$inertia.post(route('producent.out.store.data'), payload, {
          preserveScroll: true,
          onSuccess: () => {
            this.showToast("success", "Zapisano", "Dane zostały zapisane do bazy");
          },
          onError: (errors) => {
            this.showToast("error", "Błąd", "Nie udało się zapisać danych");
            console.error(errors);
          },
        });

        this.closeModal();
      }
    },

    saveField2() {
      if (this.editedEntry && this.editedField) {
        this.editedEntry[this.editedField] = this.editedValue;

        const payload = {
          prid: this.prid,
          id: this.editedEntry.id,
        };

        payload[this.editedField] = this.editedValue;

        this.$inertia.post(route('production.out.update.data'), payload, {
          preserveScroll: true,
          onSuccess: () => {
            this.showToast("success", "Zapisano", "Dane zostały zaktualizowane");
          },
          onError: (errors) => {
            this.showToast("error", "Błąd", "Nie udało się zapisać danych");
            console.error(errors);
          },
        });

        this.closeModal();
      }
    },

    closeModal() {
      this.isModalOpen = false;
      this.editedEntry = null;
      this.editedField = null;
      this.editedValue = "";
      this.modalCenaCheckbox = false;
    },

    async loadData() {
      this.isLoading = true;

      try {
        const res = await fetch(route('production.out.data', {prid: this.prid}));
        if (!res.ok) throw new Error('Błąd pobierania danych');

        const data = await res.json();
        this.productionoutentries = data;

        // Budujemy mapę po item_id → lista danych producentów dla danego artykułu
        const itemMap = new Map();
        this.producentsoutdata.forEach(prodData => {
          if (!itemMap.has(prodData.item_id)) {
            itemMap.set(prodData.item_id, []);
          }
          itemMap.get(prodData.item_id).push(prodData);
        });

        // Teraz iterujemy tylko po artykułach i ich odpowiadających producentach
        this.productionoutentries.forEach(entry => {
          const entryId = entry.item_id || entry.id || entry.item;
          const prodList = itemMap.get(entryId) || [];

          prodList.forEach(data => {
            if (data.cena != null) entry['cena_' + data.customer_id] = data.cena;
            if (data.cena_ustalona != null) entry['cena_ustalona_' + data.customer_id] = data.cena_ustalona;
            if (data.uwagi != null) entry['uwagi_' + data.customer_id] = data.uwagi;
            if (data.dostawa != null) entry['dostawa_' + data.customer_id] = data.dostawa;
            entry['selected_' + data.customer_id] = data.selected || 0;
          });
        });

      } catch (err) {
        console.error(err);
        this.productionoutentries = [];
      } finally {
        this.isLoading = false;
      }
    },

    handleSelect2() {
      $('#sel_customer_id').select2().on('select2:select', (e) => {
        this.form.customer_id = parseInt(e.params.data.id);
      });
    },

    wyczysc() {
      if (!confirm('Na pewno wyczyścić tabelę i usunąć wpisy z bazy?')) return;
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      fetch(route('production.out.data.delete', {prid: this.prid}), {
        method: 'DELETE',
        headers: {
          "X-CSRF-TOKEN": csrfToken,
          Accept: "application/json",
        }
      })
          .then(res => {
            if (!res.ok) throw new Error('Błąd usuwania danych');
            this.productionoutentries = [];
            this.showToast('info', 'Tabelę wyczyszczono', '');
          })
          .catch(err => {
            console.error(err);
            this.showToast('error', 'Błąd', 'Nie udało się usunąć danych');
          });
    },

    submitForm() {
      if (!this.form.customer_id) {
        this.showToast('error', 'Błąd', 'Proszę wybrać kontrahenta');
        return;
      }
      const dataToSend = {
        ...this.form,
        prid: this.prid,
      };

      this.$inertia.post(route('production.out.add.producent'), dataToSend, {
        onSuccess: () => {
          $('#sel_customer_id').val(null).trigger('change');
          this.form.customer_id = '';
        }
      });
    },
    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon,
        title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
  },
};
</script>
<style scoped>
.tooltip {
  opacity: 1 !important;
}
th.position-relative {
  padding-right: 2rem;
}
.modal {
  background: rgba(0, 0, 0, 0.5);
}
.table-responsive {
  position: relative;
  height: calc(100vh - 200px);
  overflow-y: auto;
}
.table-responsive thead th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}
th, td {
  padding: 8px 12px;
  border: 1px solid #ccc;
  background: white;
}

.btn-sm-oko {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-sm-oko i {
  font-size: 20px;
  line-height: 1;
}

.btn-sm-kosz {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-sm-kosz i {
  font-size: 20px;
  line-height: 1;
}
</style>
